"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.managePurchasesPrefetcher = void 0;

var managePurchasesPrefetcher = function managePurchasesPrefetcher() {
  return import(
  /* webpackChunkName: 'chunk-manage-purchases' */
  '../containers/ManagePurchasesContainer');
};

exports.managePurchasesPrefetcher = managePurchasesPrefetcher;